import { useSearchParams } from "react-router-dom";

// Keeps the list page number in the URL (?page=N) so that coming back
// from a details page restores the last visited page instead of page 1.
export const usePageParam = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = Number(searchParams.get("page")) || 1;

  const setPage = (pageNo) => {
    setSearchParams(
      (prev) => {
        const params = new URLSearchParams(prev);
        if (pageNo > 1) params.set("page", pageNo);
        else params.delete("page");
        return params;
      },
      { replace: true },
    );
  };

  return [page, setPage];
};
